import { computed } from '@vue/composition-api';
export function useModelWrapper(props, emit, name = 'modelValue') {
  return computed({
    get: () => props[name],
    set: (value) => emit(`input`, value),
  });
}
